import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const LinkWrapper = styled.span`
  a {
    border-top: 1px solid #ccc;
    display: block;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
    font-size: 1em;
    cursor: pointer;
    font-weight: ${props => (props.deviceType !== 'desktop' ? 'bold' : 'normal')};
    padding: ${props => (props.deviceType !== 'desktop' ? '10px 10px 10px 0' : '13px 10px')};
        
    &:hover {
      text-decoration: underline;
    }
  }
`;

function renderLink(tariff, deviceType) {
  return (
    <LinkWrapper key={`${tariff.label}`} deviceType={deviceType}>
      <a href={tariff.target}>
        {tariff.label}
      </a>
    </LinkWrapper>
  );
}

LinkWrapper.propTypes = {
  deviceType: PropTypes.oneOf(['desktop', 'mobile']).isRequired
};

export default renderLink;
